export enum PickerType {
    both,
    calendar,
    timer
}
